import { useCallback } from "react";

const useScrollTo = () => {
  const scrollToElement = useCallback((elementRef, containerRef, options = {}) => {
    const { delay = 50, focusDelay = 200, behavior = "smooth", block = "center" } = options;

    setTimeout(() => {
      if (elementRef.current && containerRef.current) {
        const container = containerRef.current;
        const element = elementRef.current;

        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        // Calculate scroll position to center the element in the container
        const scrollTop = container.scrollTop + (elementRect.top - containerRect.top) - containerRect.height / 2 + elementRect.height / 2;

        container.scrollTo({
          top: Math.max(0, scrollTop),
          behavior: behavior,
        });

        // Focus on the input field after scrolling
        if (focusDelay > 0) {
          setTimeout(() => {
            const inputField = element.querySelector('input[type="text"]');
            if (inputField) {
              inputField.focus();
            }
          }, focusDelay);
        }
      }
    }, delay);
  }, []);

  return { scrollToElement };
};

export default useScrollTo;
